module.exports = __webpack_public_path__ + "static/media/Тезисы_УОМШ-2021_Том_2.135d5693.pdf";